import {useEffect, useState} from 'react'
import {Outlet, useLocation, useNavigate} from 'react-router-dom'
import {HeaderWrapper} from './components/header'
// import {RightToolbar} from '../partials/layout/RightToolbar'
import {ScrollTop} from './components/scroll-top'
import {Content} from './components/content'
import {FooterWrapper} from './components/footer'
import {Sidebar} from './components/sidebar'
import {ActivityDrawer, DrawerMessenger, InviteUsers, UpgradePlan} from '../partials'
import {PageDataProvider} from './core'
import {reInitMenu} from '../helpers'
import {ToolbarWrapper} from './components/toolbar'
import {useNetworkStatus} from '../../app/hooks/useNetworkStatus'
import {Accordion, Alert, Button, Modal, ProgressBar} from 'react-bootstrap'

import Lottie from 'lottie-react'
import sendingLottie from '../../app/assets/lotties/transferData.json'
import errorLottie from '../../app/assets/lotties/errorDispatch.json'
import completedTransferLottie from '../../app/assets/lotties/completed-transfer.json'
import {IInputMutation, useDispatchesStore} from '../../app/store/dipatches'
import {useMutation} from '@apollo/client'
import {CREATE_DISPATCH} from '../../app/graphql/mutations/dispatchMutations'
import {IResCreateDispatch} from '../../app/graphql/types/despachoTypes'
import {toast} from 'react-toastify'
import {includeConector, parseId} from '../../app/helpers'

const MasterLayout = () => {
  const [gqlAddDispatch] = useMutation<IResCreateDispatch>(CREATE_DISPATCH)

  const isOnline = useNetworkStatus()
  const dispatches = useDispatchesStore((s) => s.dipatches)
  const removeDispatch = useDispatchesStore((s) => s.removeDispatch)
  const isSending = useDispatchesStore((s) => s.isSending)
  const toggleSending = useDispatchesStore((s) => s.toggleSending)
  const totalDispatches = useDispatchesStore((s) => s.totalDispatches)
  const updateTotalDispatches = useDispatchesStore((s) => s.updateTotalDispatches)
  const location = useLocation()
  const navigate = useNavigate()

  const [errorInfoDispatches, setErrorInfoDispatches] = useState<
    (IInputMutation & {errorMsg: string})[]
  >([])

  useEffect(() => {
    reInitMenu()
  }, [location.key])

  useEffect(() => {
    const sendingDispatches = async (disp: IInputMutation) => {
      const {data, errors} = await gqlAddDispatch({
        variables: {
          input: {
            ...disp,
            // product: parseId(disp.product.split('***')[0]),
            products: disp.products.map((pro) => ({
              product: parseId(pro.product.split('***')[0]),
              quantityDispatch: Number(pro.quantityDispatch),
            })),
            client: parseId(disp.client.split('***')[0]),
            product: undefined,
          },
        },
      })
      if (data && data.dispatchCreate.success) {
        removeDispatch({uuid: disp.uuid})
      } else if (data && Boolean(data.dispatchCreate.errors?.message)) {
        setErrorInfoDispatches((prev) => [
          ...prev,
          {...disp, errorMsg: data.dispatchCreate.errors?.message || 'Algo ocurrió'},
        ])
        return
      } else if (errors) {
        setErrorInfoDispatches((prev) => [
          ...prev,
          {...disp, errorMsg: errors.join(', ') || 'Algo ocurrió'},
        ])
      }
    }
    if (isOnline && isSending && dispatches.length > 0) {
      sendingDispatches(dispatches[0])
    } else if (dispatches.length === 0 && isOnline && isSending) {
      updateTotalDispatches(0)
      toast.success('Despachos actualizados correctamente')
      navigate('/dashboard')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOnline, isSending, dispatches])
  const now =
    totalDispatches === 0 ? 100 : ((totalDispatches - dispatches.length) * 100) / totalDispatches
  const label =
    totalDispatches === 0
      ? 100
      : Math.round(((totalDispatches - dispatches.length) * 100) / totalDispatches)
  return (
    <PageDataProvider>
      {!isOnline && (
        <div className='offline-alert'>
          <div className='d-flex align-items-center justify-content-center'>
            <Alert className='d-flex align-items-center gap-1' variant='danger'>
              <i className='bi bi-wifi-off fs-2 text-danger fw-bold' />
              Trabajando sin conexión a internet
            </Alert>
          </div>
        </div>
      )}
      <div className='d-flex flex-column flex-root app-root' id='kt_app_root'>
        <div className='app-page flex-column flex-column-fluid' id='kt_app_page'>
          <HeaderWrapper />
          <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
            <Sidebar />
            <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
              <div className='d-flex flex-column flex-column-fluid'>
                <ToolbarWrapper />
                <Content>
                  <Outlet />
                </Content>
              </div>
              <FooterWrapper />
            </div>
          </div>
        </div>
      </div>

      {/* begin:: Drawers */}
      <ActivityDrawer />
      {/* <RightToolbar /> */}
      <DrawerMessenger />
      {/* end:: Drawers */}

      {/* begin:: Modals */}
      <InviteUsers />
      <UpgradePlan />
      {/* end:: Modals */}
      <ScrollTop />

      <Modal show={isSending} size='lg' aria-labelledby='contained-modal-title-vcenter' centered>
        <Modal.Header closeButton>
          <Modal.Title id='contained-modal-title-vcenter'>Actualizando despachos</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {totalDispatches > 0 && errorInfoDispatches.length === 0 ? (
            <>
              <span className='text-center d-block'>Enviado despachos...</span>
              <div
                style={{width: '100%'}}
                className='d-flex justify-content-center align-items-center'
              >
                <Lottie animationData={sendingLottie} style={{width: '60%'}} />
              </div>
            </>
          ) : errorInfoDispatches.length > 0 ? (
            <>
              <span className='text-center d-block'>Ocurrió un error ❌</span>
              <div
                style={{width: '100%'}}
                className='d-flex justify-content-center align-items-center'
              >
                <Lottie animationData={errorLottie} style={{width: '60%'}} />
              </div>
            </>
          ) : (
            <>
              <span className='text-center d-block'>Completado ✅</span>
              <div
                style={{width: '100%'}}
                className='d-flex justify-content-center align-items-center'
              >
                <Lottie animationData={completedTransferLottie} style={{width: '30%'}} />
              </div>
            </>
          )}
          <div>
            <ProgressBar now={now} label={`${label}%`} />
          </div>
          {errorInfoDispatches.length > 0 && (
            <div>
              <h5>Errores al despachar</h5>
              <Accordion>
                {errorInfoDispatches.map((infoError, idx) => (
                  <Accordion.Item eventKey={`${idx}`} key={infoError.uuid}>
                    <Accordion.Header>
                      {infoError.products[0].quantityDispatch}{' '}
                      {includeConector(infoError.products[0].product.split('***')[1])}
                    </Accordion.Header>
                    <Accordion.Body>{infoError.errorMsg}</Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            </div>
          )}
        </Modal.Body>
        {(dispatches.length === 0 || errorInfoDispatches.length > 0) && (
          <Modal.Footer>
            <Button variant='success' onClick={() => toggleSending(false)}>
              Aceptar
            </Button>
          </Modal.Footer>
        )}
      </Modal>
    </PageDataProvider>
  )
}

export {MasterLayout}
